package features.booking

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TrackingScreen(
    viewModel: TrackingViewModel,
    onVolver: () -> Unit
) {
    val infoRastreo by viewModel.infoRastreo.collectAsState()
    val isLoading by viewModel.isLoading.collectAsState()
    val error by viewModel.error.collectAsState()

    var codigoInput by remember { mutableStateOf("") }
    var mostrarEscanerTracking by remember { mutableStateOf(false) }

    val smartvanDark = SmartVanColors.AzulOscuro
    val smartvanCyan = SmartVanColors.CyanAccent

    DisposableEffect(Unit) {
        onDispose {
            viewModel.detenerPolling()
        }
    }

    if (mostrarEscanerTracking) {
        org.example.abigail.QRScannerScreen(
            onCodigoEscaneado = { codigo ->
                mostrarEscanerTracking = false
                codigoInput = codigo
                viewModel.buscarViajePorCodigo(codigo)
            },
            onCerrar = { mostrarEscanerTracking = false }
        )
        return
    }

    Scaffold(
        topBar = {
            TopAppBar(
                title = {
                    Column {
                        Text("Rastreo en Vivo", fontWeight = FontWeight.Bold, fontSize = 17.sp, color = Color.White)
                        Text("Sigue tu viaje en tiempo real", fontSize = 11.sp, color = Color.White.copy(alpha = 0.7f))
                    }
                },
                navigationIcon = {
                    IconButton(onClick = {
                        viewModel.limpiar()
                        onVolver()
                    }) {
                        Icon(Icons.Filled.ArrowBack, contentDescription = "Volver", tint = Color.White)
                    }
                },
                colors = TopAppBarDefaults.topAppBarColors(containerColor = smartvanDark)
            )
        }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .background(SmartVanColors.FondoClaro)
                .padding(paddingValues)
                .padding(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (infoRastreo == null) {
                // ========== PANTALLA DE ENTRADA DE CODIGO ==========
                Spacer(modifier = Modifier.height(30.dp))

                // Icono grande
                Box(
                    modifier = Modifier
                        .size(80.dp)
                        .clip(CircleShape)
                        .background(
                            Brush.linearGradient(
                                colors = listOf(smartvanCyan, Color(0xFF0097A7))
                            )
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        Icons.Filled.LocationOn,
                        contentDescription = null,
                        tint = Color.White,
                        modifier = Modifier.size(40.dp)
                    )
                }

                Spacer(modifier = Modifier.height(20.dp))

                Text(
                    "Rastrea tu viaje",
                    style = MaterialTheme.typography.headlineSmall,
                    fontWeight = FontWeight.Black,
                    color = smartvanDark
                )

                Spacer(modifier = Modifier.height(8.dp))

                Text(
                    "Ingresa el codigo de viaje que aparece en tu boleto para ver la ubicacion de la unidad en tiempo real",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.padding(horizontal = 20.dp)
                )

                Spacer(modifier = Modifier.height(24.dp))

                // Boton escanear QR
                Button(
                    onClick = { mostrarEscanerTracking = true },
                    modifier = Modifier.fillMaxWidth().height(52.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = smartvanDark),
                    shape = RoundedCornerShape(14.dp)
                ) {
                    Icon(Icons.Filled.QrCode2, contentDescription = null, tint = Color.White, modifier = Modifier.size(22.dp))
                    Spacer(modifier = Modifier.width(8.dp))
                    Text("Escanear QR del Boleto", fontWeight = FontWeight.Bold, color = Color.White, fontSize = 15.sp)
                }

                Spacer(modifier = Modifier.height(12.dp))

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    HorizontalDivider(modifier = Modifier.weight(1f), color = Color.LightGray)
                    Text("  o ingresa el codigo  ", color = Color.Gray, style = MaterialTheme.typography.labelSmall)
                    HorizontalDivider(modifier = Modifier.weight(1f), color = Color.LightGray)
                }

                Spacer(modifier = Modifier.height(12.dp))

                // Input del codigo
                OutlinedTextField(
                    value = codigoInput,
                    onValueChange = { codigoInput = it },
                    label = { Text("Codigo de Viaje") },
                    placeholder = { Text("SMARTVAN-17470...") },
                    leadingIcon = { Icon(Icons.Filled.ConfirmationNumber, contentDescription = null, tint = smartvanCyan) },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedBorderColor = smartvanCyan,
                        focusedLabelColor = smartvanCyan,
                        cursorColor = smartvanCyan,
                        unfocusedContainerColor = Color.White,
                        focusedContainerColor = Color.White
                    )
                )

                Spacer(modifier = Modifier.height(16.dp))

                Button(
                    onClick = { viewModel.buscarViajePorCodigo(codigoInput) },
                    modifier = Modifier.fillMaxWidth().height(52.dp),
                    enabled = !isLoading && codigoInput.isNotBlank(),
                    colors = ButtonDefaults.buttonColors(containerColor = smartvanCyan),
                    shape = RoundedCornerShape(14.dp)
                ) {
                    if (isLoading) {
                        CircularProgressIndicator(color = Color.White, modifier = Modifier.size(22.dp), strokeWidth = 2.dp)
                        Spacer(modifier = Modifier.width(10.dp))
                        Text("Buscando...", fontWeight = FontWeight.Bold, color = Color.White)
                    } else {
                        Icon(Icons.Filled.Search, contentDescription = null, tint = Color.White, modifier = Modifier.size(20.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text("Buscar Viaje", fontWeight = FontWeight.Bold, color = Color.White, fontSize = 16.sp)
                    }
                }

                // Error
                error?.let { msg ->
                    Spacer(modifier = Modifier.height(16.dp))
                    Card(
                        colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoRojo),
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Row(modifier = Modifier.padding(14.dp), verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.ErrorOutline, contentDescription = null, tint = Color(0xFFEF5350), modifier = Modifier.size(22.dp))
                            Spacer(modifier = Modifier.width(10.dp))
                            Text(msg, color = Color(0xFFEF5350), fontSize = 14.sp)
                        }
                    }
                }

                Spacer(modifier = Modifier.weight(1f))

                // Hint
                Card(
                    colors = CardDefaults.cardColors(containerColor = Color(0xFFF1F8E9)),
                    shape = RoundedCornerShape(12.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(modifier = Modifier.padding(14.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.Info, contentDescription = null, tint = SmartVanColors.VerdeOscuro, modifier = Modifier.size(20.dp))
                        Spacer(modifier = Modifier.width(10.dp))
                        Text(
                            "Tu codigo de viaje lo encuentras en tu boleto digital, debajo del QR.",
                            fontSize = 12.sp,
                            color = SmartVanColors.VerdeOscuro
                        )
                    }
                }

            } else {
                // ========== PANTALLA DE RESULTADO / ESTADO DEL VIAJE ==========
                val info = infoRastreo!!

                Spacer(modifier = Modifier.height(12.dp))

                // Trip info card
                Card(
                    colors = CardDefaults.cardColors(containerColor = smartvanDark),
                    shape = RoundedCornerShape(16.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Column(modifier = Modifier.padding(18.dp)) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.DirectionsBus, contentDescription = null, tint = smartvanCyan, modifier = Modifier.size(22.dp))
                            Spacer(modifier = Modifier.width(8.dp))
                            Text(info.ruta, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 17.sp)
                        }
                        Spacer(modifier = Modifier.height(14.dp))
                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                            Column {
                                Text("Fecha", color = Color.White.copy(alpha = 0.6f), fontSize = 11.sp)
                                Text(info.fecha, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 14.sp)
                            }
                            Column {
                                Text("Horario", color = Color.White.copy(alpha = 0.6f), fontSize = 11.sp)
                                Text(info.horario, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 14.sp)
                            }
                            Column {
                                Text("Asiento", color = Color.White.copy(alpha = 0.6f), fontSize = 11.sp)
                                Text("${info.asiento}", color = Color.White, fontWeight = FontWeight.Bold, fontSize = 14.sp)
                            }
                        }
                        if (info.pasajero.isNotBlank()) {
                            Spacer(modifier = Modifier.height(8.dp))
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Icon(Icons.Filled.Person, contentDescription = null, tint = smartvanCyan, modifier = Modifier.size(16.dp))
                                Spacer(modifier = Modifier.width(6.dp))
                                Text(info.pasajero, color = Color.White, fontSize = 13.sp)
                            }
                        }
                    }
                }

                Spacer(modifier = Modifier.height(12.dp))

                // Status card
                val (statusBg, statusColor, statusIcon, statusText) = when (info.estado) {
                    "en_curso" -> listOf(Color(0xFFE8F5E9), SmartVanColors.VerdeOscuro, Icons.Filled.Navigation, "En Camino")
                    "finalizado" -> listOf(SmartVanColors.FondoGrisClaro, Color(0xFF757575), Icons.Filled.CheckCircle, "Viaje Finalizado")
                    else -> listOf(SmartVanColors.FondoAmarillo, Color(0xFFF57F17), Icons.Filled.Schedule, "Esperando Inicio")
                }

                Card(
                    colors = CardDefaults.cardColors(containerColor = statusBg as Color),
                    shape = RoundedCornerShape(14.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier.padding(16.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier
                                .size(44.dp)
                                .background((statusColor as Color).copy(alpha = 0.15f), CircleShape),
                            contentAlignment = Alignment.Center
                        ) {
                            Icon(statusIcon as androidx.compose.ui.graphics.vector.ImageVector, contentDescription = null, tint = statusColor, modifier = Modifier.size(24.dp))
                        }
                        Spacer(modifier = Modifier.width(14.dp))
                        Column(modifier = Modifier.weight(1f)) {
                            Text(statusText as String, fontWeight = FontWeight.Bold, fontSize = 16.sp, color = statusColor)
                            if (info.estado == "en_curso") {
                                Text("La ubicacion se actualiza cada 10 segundos", fontSize = 11.sp, color = Color.Gray)
                            }
                            if (info.estado == "no_iniciado") {
                                Text("El chofer aún no ha iniciado el viaje", fontSize = 11.sp, color = Color.Gray)
                            }
                            if (info.estado == "finalizado") {
                                Text("El viaje ha concluido", fontSize = 11.sp, color = Color.Gray)
                            }
                        }
                    }
                }

                Spacer(modifier = Modifier.height(16.dp))

                // Boton abrir mapa
                if (info.estado == "en_curso" || (info.estado == "finalizado" && info.lat != 0.0)) {
                    Button(
                        onClick = {
                            org.example.abigail.abrirMapaRastreo(info.ruta, info.fecha, info.horario)
                        },
                        modifier = Modifier.fillMaxWidth().height(56.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                        shape = RoundedCornerShape(14.dp)
                    ) {
                        Icon(Icons.Filled.Map, contentDescription = null, tint = Color.White, modifier = Modifier.size(24.dp))
                        Spacer(modifier = Modifier.width(10.dp))
                        Text("Abrir Mapa en Vivo", fontWeight = FontWeight.Bold, color = Color.White, fontSize = 16.sp)
                    }

                    Spacer(modifier = Modifier.height(10.dp))

                    if (info.lat != 0.0 && info.lng != 0.0) {
                        Card(
                            colors = CardDefaults.cardColors(containerColor = Color.White),
                            shape = RoundedCornerShape(12.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Row(
                                modifier = Modifier.padding(14.dp).fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.LocationOn, contentDescription = null, tint = smartvanCyan, modifier = Modifier.size(18.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Column {
                                        Text("Coordenadas", fontSize = 11.sp, color = Color.Gray)
                                        Text("${info.lat}, ${info.lng}", fontSize = 12.sp, color = smartvanDark, fontWeight = FontWeight.Medium)
                                    }
                                }
                                if (info.ultimaActualizacion.isNotBlank()) {
                                    Column(horizontalAlignment = Alignment.End) {
                                        Text("Actualizado", fontSize = 11.sp, color = Color.Gray)
                                        Text(formatearHora(info.ultimaActualizacion), fontSize = 12.sp, color = smartvanDark, fontWeight = FontWeight.Medium)
                                    }
                                }
                            }
                            // Aviso si la posición lleva más de 2 min sin actualizarse (posible pérdida de señal)
                            val msUlt = info.ultimaActualizacion.toLongOrNull() ?: 0L
                            val minDesfase = if (msUlt > 0L) (org.example.abigail.obtenerMilisegundosActuales() - msUlt) / 60000L else -1L
                            if (info.estado == "en_curso" && minDesfase >= 2L) {
                                Spacer(modifier = Modifier.height(8.dp))
                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Filled.Warning, contentDescription = null, tint = Color(0xFFF57F17), modifier = Modifier.size(16.dp))
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Text("Posición sin actualizar hace $minDesfase min — el chofer pudo perder señal.", fontSize = 11.sp, color = Color(0xFFF57F17))
                                }
                            }
                        }
                    }
                } else if (info.estado == "no_iniciado") {
                    Card(
                        colors = CardDefaults.cardColors(containerColor = SmartVanColors.FondoAmarillo),
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.Info, contentDescription = null, tint = Color(0xFFF57F17), modifier = Modifier.size(22.dp))
                            Spacer(modifier = Modifier.width(10.dp))
                            Text(
                                "El mapa estara disponible cuando el chofer inicie el viaje. Esta pagina se actualiza automaticamente.",
                                fontSize = 13.sp,
                                color = Color(0xFFF57F17)
                            )
                        }
                    }
                }

                Spacer(modifier = Modifier.weight(1f))

                // Boton buscar otro codigo
                OutlinedButton(
                    onClick = { viewModel.limpiar() },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.outlinedButtonColors(contentColor = smartvanDark)
                ) {
                    Icon(Icons.Filled.Search, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(modifier = Modifier.width(8.dp))
                    Text("Buscar otro viaje")
                }
            }
        }
    }
}

private fun formatearHora(milisStr: String): String {
    return try {
        val millis = milisStr.toLong()
        org.example.abigail.formatMillisToTime(millis)
    } catch (e: Exception) { "--:--" }
}
